<div class="center" *ngIf="loading" style="margin-top: 40px;">
    <mat-spinner [diameter]="25"></mat-spinner>
    <p style="margin-right: 16px;">در حال بارگذاری...</p>
</div>

<ng-container *ngIf="!loading">
    <div class="container1000">
        <h1>گزارشات</h1>
    </div>
</ng-container>
